import * as React from "react";

import "./instruction.scss";

import {cs} from "@Common/react/chain-services";

export const Instruction = ({text}) => cs(
    ({}) => (
        <div className="instruction instruction-58r">
            <div className="box">
                <div className="icon">
                    <i className="fa fa-info"/>
                </div>
                <div className="text">
                    {text}
                </div>
            </div>
        </div>
    )
);